var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconPremiumOvato = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62.201,
    viewBox: "0 0 62 62.201",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4911",
    "data-name": "Group 4911",
    transform: "translate(-359.765 -16.781)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_211",
    "data-name": "Ellipse 211",
    cx: 31,
    cy: 31,
    r: 31,
    transform: "translate(359.765 16.781)",
    fill: "#fff",
    opacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6655",
    "data-name": "Path 6655",
    d: "M-2019.782,703.83A30.547,30.547,0,0,0-1991.6,722.6a30.558,30.558,0,0,0,29.423-22.356c-3.142,7.315-9.049,14.739-18,12.742-5.667-1.265-7.86-1.581-11.74-1.581-6.178,0-9.09,1.581-14.211,1.581C-2011.492,712.99-2015.909,711.049-2019.782,703.83Z",
    transform: "translate(2382.345 -643.622)",
    fill: "#454f9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6656",
    "data-name": "Path 6656",
    d: "M-1981.632,48.453a30.557,30.557,0,0,0-30.059-25.15,30.559,30.559,0,0,0-29.44,22.414c3.244-6.953,9.007-13.589,17.526-11.688,5.668,1.265,7.862,1.581,11.74,1.581,6.179,0,9.089-1.581,14.211-1.581C-1991.164,34.029-1986.062,36.868-1981.632,48.453Z",
    transform: "translate(2402.436 -6.469)",
    fill: "#454f9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6657",
    "data-name": "Path 6657",
    d: "M-1863.293,315.744h-6.868a14.782,14.782,0,0,0-14.012-10.545,14.782,14.782,0,0,0-14.012,10.545h-6.589v3.537h5.934q-.036.52-.036,1.049c0,.3.01.592.025.885h-5.923v3.537h6.538a14.789,14.789,0,0,0,14.063,10.71,14.788,14.788,0,0,0,14.063-10.71h6.818v-3.537h-6.2c.017-.293.026-.588.026-.885,0-.353-.013-.7-.036-1.05h6.213Zm-20.881,12.693a8,8,0,0,1-7.877-8.106,8,8,0,0,1,7.877-8.106,8,8,0,0,1,7.877,8.106A8,8,0,0,1-1884.173,328.437Z",
    transform: "translate(2274.702 -272.211)",
    fill: "#454f9a"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconPremiumOvato, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-premium-ovato.0af16b93.svg";
export { ForwardRef as ReactComponent };